export const CustomerRecordIcon = ({ fill }) => {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.58638 0C4.51261 0 2.82562 1.68698 2.82562 3.76076C2.82562 5.83454 4.51261 7.52152 6.58638 7.52152C8.66016 7.52152 10.3473 5.83454 10.3473 3.76076C10.3473 1.68698 8.66016 0 6.58638 0Z"
        fill={fill}
      />
      <path
        d="M6.58616 8.41406C2.95452 8.41406 0 11.3686 0 15.0002H13.1725C13.1727 11.3686 10.218 8.41406 6.58616 8.41406Z"
        fill={fill}
      />
    </svg>
  );
};
